import React, { useEffect, useRef, useState } from 'react'
import styles from './index.module.css'
import { useDispatch, useSelector } from 'react-redux'
import Loader from '../../../components/Loader'
import Empty from '../../../components/Empty'
import { BiTrash } from 'react-icons/bi'
import Confirmation from '../../../components/Confirmation/Confirmation'
import { deleteAds } from '../../../actions/ads'
import useDoubleClick from 'use-double-click'
import classNames from 'classnames'
import { getCourses } from '../../../actions/common'

const Index = ({ date, setType }) => {

    const dispatch = useDispatch();
    const [confirmation, setConfirmation] = useState(false);
    const [selectedId, setSelectedId] = useState(null);

    const { list, loading } = useSelector(state => state.ads)

    useEffect(() => {
        dispatch(getCourses())
    }, [])

    const acceptConfirmation = () => {
        dispatch(deleteAds(confirmation.postid, date.from, date.to));
        setConfirmation(false);
    };

    const rejectConfirmation = () => {
        setConfirmation(false);
    };

    return (
        <div className={styles.container}>
            {confirmation && <Confirmation
                top="30px"
                left="40px"
                title="Удалить объявление?"
                confirmation={confirmation.name}
                acceptConfirmation={() => acceptConfirmation(confirmation.postid)}
                rejectConfirmation={rejectConfirmation} />}
            {loading
                ? <Loader />
                : !!list?.length
                    ? list.map((item) => (
                        <AdsItem
                            key={item.postid}
                            data={item}
                            selected={selectedId === item.postid}
                            onSelect={() => setSelectedId(item.postid)}
                            onOpen={() => setType(item.postid)}
                            onDelete={() => setConfirmation(item)}
                        />
                    ))
                    : <Empty />
            }
        </div>
    )
}

const AdsItem = ({ data, selected, onSelect, onOpen, onDelete }) => {
    const rowRef = useRef()

    useDoubleClick({
        onSingleClick: onSelect,
        onDoubleClick: onOpen,
        ref: rowRef,
        latency: 250,
    })

    return (
        <div
            ref={rowRef}
            className={classNames(styles.adItem, { [styles.selectedRow]: selected })}
            style={{ cursor: 'pointer' }}
        >
            <div className={styles.adHeader}>
                <span>{data.posted}, {data.name}</span>
                <button
                    className={styles.deleteIcon}
                    onClick={(e) => { e.stopPropagation(); onDelete(); }}
                    title="Удалить"
                >
                    <BiTrash />
                </button>
            </div>
            <div><span className={styles.adLabel}>Предмет:</span> {data.course || ''}</div>
            {data.text && <div className={styles.textTruncate}><span className={styles.adLabel}>Текст:</span> {data.text.replace(/<[^>]*>/g, '')}</div>}
        </div>
    )
}

export default Index
